import { render, staticRenderFns } from "./BarDifference.vue?vue&type=template&id=275a428e&scoped=true&"
import script from "./BarDifference.vue?vue&type=script&lang=ts&"
export * from "./BarDifference.vue?vue&type=script&lang=ts&"
import style0 from "./BarDifference.vue?vue&type=style&index=0&id=275a428e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a428e",
  null
  
)

export default component.exports